import {IS_FLIGHT_VALID} from "../flight-form/flight-row-data";

export const DATA = {
    flights: [],
};

export const FLIGHTS_VALIDATOR = inputFligths => inputFligths.some(f => f.selected === true) && inputFligths.every(f => IS_FLIGHT_VALID(f));